export interface RetoolURIArgs {
  uuid: string;
  queryParams?: { [key: string]: string };
}
function retoolURI({ uuid, queryParams }: RetoolURIArgs) {
  const extendedQueryParams = { ...(queryParams || {}), _hideNav: true };

  return `https://brilliant.tryretool.com/apps/${uuid}/?${Object.entries(extendedQueryParams)
    .map(entry => entry.join('='))
    .join('&')}`;
}

export default {
  authorsDashboard: retoolURI({
    uuid: '3fa85a80-7704-11ed-a9f9-cb4b075dae8c',
  }),
  courseVersions: (courseSlug: string) =>
    retoolURI({
      uuid: '50e515f0-765e-11ed-96cc-271d0db7cc70',
      queryParams: { course_slug: courseSlug },
    }),
  lessonVersions: (lessonSlug: string) =>
    retoolURI({
      uuid: '80a8430e-a3ed-11ed-b9d3-aff0e51b612f',
      queryParams: { lesson_slug: lessonSlug },
    }),
  packageVersions: (packageName: string) =>
    retoolURI({
      uuid: '2b87ced0-9b6e-11ed-a2f4-070bbfdf2db7',
      queryParams: { package_name: packageName },
    }),
  packageView: (packageName: string, versionName: string) =>
    retoolURI({
      uuid: '77a272d2-9c0b-11ed-8e6f-13eb96454135',
      queryParams: { package_name: packageName, version_name: versionName },
    }),
};
